/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Styled Filter Action Button default color
 *
 * @file FilterActionButtonDefault.jsx
 * @author Srinivasan Bakthavatchalam
 * @since 1.0.1
 */

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const FilterActionButtonDefault = withStyles((theme) => ({
  root: {
    fontFamily: 'Hind',
    padding: 0,
    height: 40,
    borderColor: theme.color.textPrimary,
    color: theme.color.textPrimary,
    '&:hover': {
      borderColor: theme.color.textPrimary,
      color: theme.color.textPrimary
    }
  },
  disabled: {
    backgroundColor: 'transparent !important'
  }
}))(Button);

export default FilterActionButtonDefault;
